import { Modal, Button } from "react-bootstrap";
import React, { useEffect } from "react";
import "../../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";


const specialitySchema = Yup.object().shape({
    name: Yup.string().required("Speciality name is required"),
});

const SpecialityForm = ({ mode, showModal, hideModal, initialData = {}, onSuccess }) => {
    const isEditMode = mode === "edit";

    const onSubmit = async (values) => {
        try {
            const endpoint = isEditMode ? `/speciality/${initialData.specialty_id}` : "/speciality";
            const method = isEditMode ? axios.put : axios.post;

            await method(endpoint, values);
            toast.success(`Speciality ${isEditMode ? "updated" : "added"} successfully.`);
            onSuccess();
            hideModal();
        } catch (error) {
            toast.error(`Failed to ${isEditMode ? "update" : "add"} speciality.`);

            if (error.response && error.response.data && error.response.data.errors) {mat
                toast.error(error.response.data.errors);     
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            }
        }
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, submitForm, resetForm } = useFormik({
        initialValues: {
            name: initialData.name || "",
        },
        validationSchema: specialitySchema,
        onSubmit,
    });

    useEffect(() => {
        if (showModal && !isEditMode) {
            resetForm();
        }
    }, [showModal, isEditMode, resetForm]);

    return (
        <form onSubmit={handleSubmit} autoComplete="off">
            <Modal
             style={{marginTop: "60px"}} 
                show={showModal}
                onHide={hideModal}
                backdrop={false}
                keyboard={false}
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{isEditMode ? "Edit Speciality" : "Add Speciality"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label htmlFor="name">Speciality Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        {errors.name && touched.name && <div className="error">{errors.name}</div>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={hideModal}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit" disabled={isSubmitting} onClick={submitForm}>
                        {isEditMode ? "Update" : "Submit"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </form>
    );
};

export default SpecialityForm;
